import { useRef } from 'react';

import * as Styled from './Accordion.styled';
import type { AccordionProps } from './Accordion.typed';
import Icon from '../Icon/Icon';
import Text from '../Text/Text';
import withDefaultProps from '../../hoc/withDefaultProps';
import withStringOrComponent from '../../hoc/withStringOrComponent';

/**
 * Created by jay on 21/03/2023
 **/

const Accordion = (props: AccordionProps) => {
  const { isOpen, onChange, header, content } = props;
  const heading = withStringOrComponent(header, Accordion.Heading);
  const headerRef = useRef<HTMLDivElement | null>(null);

  const onKeyDown = (event: React.KeyboardEvent) => {
    const key = event.code.toLowerCase();
    const isFocussed = document.activeElement === headerRef.current;

    if (isFocussed && (key === 'enter' || key === 'space')) {
      event.preventDefault();
      onChange();
    }
  };

  return (
    <Styled.Accordion>
      <Styled.Header
        ref={headerRef}
        tabIndex={0}
        role="button"
        aria-expanded={isOpen}
        onClick={onChange}
        onKeyDown={onKeyDown}
      >
        <div>{heading}</div>
        <Icon
          size="m"
          color="#333"
          name={isOpen ? 'RemoveOutline' : 'AddOutline'}
        />
      </Styled.Header>
      {isOpen && <Styled.Body>{content}</Styled.Body>}
    </Styled.Accordion>
  );
};

Accordion.Heading = withDefaultProps(Text, {
  weight: 'bold',
  as: 'h3',
  color: '#333',
  size: 'm',
  lineHeight: 'm',
});

export default Accordion;
